"use strict";
exports.__esModule = true;
exports.SETTINGS_SLC_PAYMENT_SCHEDULE_CONTENT = void 0;
exports.SETTINGS_SLC_PAYMENT_SCHEDULE_CONTENT = {
    HEADER: 'Based on your estimated rent of {{rent}}, this is your recurring payment schedule.',
    EDIT_LABEL: {
        ENABLED: 'Pay with your deposit',
        DISABLED: 'Pay with your debit card'
    }
};
